// components/GovernanceGroup.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { EmployeeCard } from "components/EmployeeCard";
import { useTranslation } from "react-i18next";

const GovernanceGroup = ({ employees, getTranslatedField, classes }) => {
  const governanceEmployees = employees.filter(
    (emp) => emp.role?.position_en === "Governance"
  );

  const { i18n } = useTranslation();

  if (governanceEmployees.length === 0) return null;

  // Маппинг английского ключа роли → локализованное название
  const getLocalizedRoleTitle = (roleEn, lang) => {
    const roleMap = {
      Governance: {
        ru: "Правление",
        ky: "Башкармалык",
        en: "Governance",
      },
      "The Audit Commission": {
        ru: "Ревизионная комиссия",
        ky: "Ревизиялык комиссия",
        en: "The Audit Commission",
      },
      Management: {
        ru: "Дирекция",
        ky: "Дирекция",
        en: "Management",
      },
    };

    return roleMap[roleEn]?.[lang] || roleMap[roleEn]?.en || roleEn;
  };

  // Разбиваем массив на части
  const firstRow = governanceEmployees.slice(0, 2); // первые 2
  const secondRow = governanceEmployees.slice(2, 6); // следующие 4
  const remaining = governanceEmployees.slice(6); // остальные

  return (
    <Box sx={{ marginBottom: 5 }}>
      <Typography className={classes.title}>
        {getLocalizedRoleTitle("Governance", i18n.language)}
      </Typography>

      {/* Первый ряд: 2 карты */}
      {firstRow.length > 0 && (
        <Box className={classes.teamList}>
          {firstRow.map((employee) => (
            <EmployeeCard
              key={employee.id}
              employee={{
                id: employee.id,
                name: getTranslatedField(employee, "name"),
                position: getTranslatedField(employee, "position"),
                image: employee.image?.trim(),

                contact_ru: employee.contact_ru,
                contact_en: employee.contact_en,
                contact_ky: employee.contact_ky,

                simple_position_ru: employee.simple_position_ru,
                simple_position_en: employee.simple_position_en,
                simple_position_ky: employee.simple_position_ky,
              }}
            />
          ))}
        </Box>
      )}

      {/* Второй ряд: 4 карты */}
      {secondRow.length > 0 && (
        <Box className={classes.teamList}>
          {secondRow.map((employee) => (
            <EmployeeCard
              key={employee.id}
              employee={{
                id: employee.id,
                name: getTranslatedField(employee, "name"),
                position: getTranslatedField(employee, "position"),
                image: employee.image?.trim(),
                
                contact_ru: employee.contact_ru,
                contact_en: employee.contact_en,
                contact_ky: employee.contact_ky,

                simple_position_ru: employee.simple_position_ru,
                simple_position_en: employee.simple_position_en,
                simple_position_ky: employee.simple_position_ky,
              }}
            />
          ))}
        </Box>
      )}

      {/* Остальные: можно тоже в 4 колонки или как угодно */}
      {remaining.length > 0 && (
        <Box className={classes.teamList}>
          {remaining.map((employee) => (
            <EmployeeCard
              key={employee.id}
              employee={{
                id: employee.id,
                name: getTranslatedField(employee, "name"),
                position: getTranslatedField(employee, "position"),
                image: employee.image?.trim(),
                 
                contact_ru: employee.contact_ru,
                contact_en: employee.contact_en,
                contact_ky: employee.contact_ky,
                
                simple_position_ru: employee.simple_position_ru,
                simple_position_en: employee.simple_position_en,
                simple_position_ky: employee.simple_position_ky,
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default GovernanceGroup;